<style>
.coder {
  width: 200px;
  height: 200px;
}
</style>
<template>
  <div class="link-views white-bg">
    <Form>
      <FormItem label="密码修改：">
        <Button type="primary" @click="showModalFn('psw', 'showModalPsw')"
          >点击修改</Button
        >
      </FormItem>
      <FormItem label="手机号码：">
        <Input v-model="TelephoneObj.Telephone" disabled style="width: 200px" />
        <a @click="showModalFn('psw', 'showModalTel')"
          >&nbsp;&nbsp;更换手机号码</a
        >
      </FormItem>
      <FormItem label="邮箱账号：">
        <Input v-model="TelephoneObj.Email" disabled style="width: 200px" />
        <a @click="showModalFn('psw', 'showModalEml')"
          >&nbsp;&nbsp;更换邮箱账号</a
        >
      </FormItem>
      <FormItem label="所属学院：">
        <Select
          v-model="defEditem.CollegeId"
          filterable
          disabled
          style="width: 200px"
          @on-change="(val) => getClassByCollegeId(val)"
        >
          <i-option
            v-for="item in collegeList"
            :value="item.CollegeId"
            :key="item.CollegeId"
            >{{ item.CollegeName }}</i-option
          >
        </Select>
        <a @click="showModalFn('editem', 'showModalCo')"
          >&nbsp;&nbsp;设置所属学院</a
        >
      </FormItem>
      <FormItem label="负责班级：" v-if="rule.Status == '教师'">
        <Select
          v-model="defEditem.classList"
          multiple
          disabled
          style="width: 400px"
        >
          <i-option
            v-for="item in classList"
            :value="item.ClassId"
            :key="item.ClassId"
            >{{ item.ClassName }}</i-option
          >
        </Select>
      </FormItem>
      <FormItem label="所属班级：" v-if="rule.Status == '学生'">
        <Select v-model="defEditem.ClassId" disabled style="width: 200px">
          <i-option
            v-for="item in classList"
            :value="item.ClassId"
            :key="item.ClassId"
            >{{ item.ClassName }}</i-option
          >
        </Select>
      </FormItem>
    </Form>
    <!-- 修改密码 -->
    <Modal v-model="showModalPsw" :mask-closable="false" title="修改密码">
      <Form ref="psw" :label-width="110" :model="psw" :rules="rulePsw">
        <FormItem label="原密码：" prop="UserPwd">
          <Input
            placeholder="请输入原密码"
            v-model="psw.UserPwd"
            :type="UserPwdType"
          />
          <Icon
            :type="UserPwdType == 'password' ? 'md-eye' : 'md-eye-off'"
            slot="suffix"
            @click="show('UserPwdType')"
          />
        </FormItem>
        <FormItem label="新密码：" prop="NewPwd1">
          <Input
            placeholder="请输入新密码"
            v-model="psw.NewPwd1"
            :type="NewPwd1Type"
          />
          <Icon
            :type="NewPwd1Type == 'password' ? 'md-eye' : 'md-eye-off'"
            slot="suffix"
            @click="show('NewPwd1Type')"
          />
        </FormItem>
        <FormItem label="确认新密码：" prop="NewPwd2">
          <Input
            placeholder="请输入再次输入新密码"
            v-model="psw.NewPwd2"
            :type="NewPwd2Type"
          />
          <Icon
            :type="NewPwd2Type == 'password' ? 'md-eye' : 'md-eye-off'"
            slot="suffix"
            @click="show('NewPwd2Type')"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showModalPsw = false">取消</Button>
        <Button type="primary" @click="sureChangePsw('psw')">确定</Button>
      </div>
    </Modal>
    <!-- 修改手机号 -->
    <Modal v-model="showModalTel" :mask-closable="false" title="修改手机号">
      <Form
        ref="TelephoneObj"
        :label-width="100"
        :model="TelephoneObj"
        :rules="ruleTel"
      >
        <FormItem label="新手机号：" prop="Telephone">
          <Input
            placeholder="请输入新手机号"
            v-model="TelephoneObj.Telephone"
            clearable
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showModalTel = false">取消</Button>
        <Button type="primary" @click="sureChangeTel('TelephoneObj')"
          >确定</Button
        >
      </div>
    </Modal>
    <!-- 修改邮箱 -->
    <Modal v-model="showModalEml" :mask-closable="false" title="修改邮箱">
      <Form
        ref="EmailObj"
        :label-width="100"
        :model="TelephoneObj"
        :rules="ruleEmail"
      >
        <FormItem label="新邮箱：" prop="Email">
          <Input
            placeholder="请输入新邮箱："
            v-model="TelephoneObj.Email"
            clearable
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showModalEml = false">取消</Button>
        <Button type="primary" @click="sureChangeEmail('EmailObj')"
          >确定</Button
        >
      </div>
    </Modal>

    <!-- 设置学院班级 -->
    <Modal v-model="showModalCo" :mask-closable="false" title="选择学院 / 班级">
      <Form
        ref="editem"
        :label-width="100"
        :model="editem"
        :rules="ruleValidate"
      >
        <FormItem label="选择学院：" prop="CollegeId">
          <Select
            v-model="editem.CollegeId"
            filterable
            @on-change="(val) => getClassByCollegeId(val)"
          >
            <i-option
              v-for="item in collegeList"
              :value="item.CollegeId"
              :key="item.CollegeId"
              >{{ item.CollegeName }}</i-option
            >
          </Select>
        </FormItem>
        <FormItem
          label="选择班级："
          prop="classList"
          v-if="rule.Status == '教师'"
        >
          <Select v-model="editem.classList" multiple filterable>
            <i-option
              v-for="item in classList"
              :value="item.ClassId"
              :key="item.ClassId"
              >{{ item.ClassName }}</i-option
            >
          </Select>
        </FormItem>
        <FormItem
          label="选择班级："
          prop="ClassId"
          v-if="rule.Status == '学生'"
        >
          <Select v-model="editem.ClassId" filterable>
            <i-option
              v-for="item in classList"
              :value="item.ClassId"
              :key="item.ClassId"
              >{{ item.ClassName }}</i-option
            >
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showModalCo = false">取消</Button>
        <Button type="primary" @click="sureChangeColleg('editem')">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  resetTokenAndClearUser,
  validatePhoto,
  validateEmail,
} from "../../../utils";
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/public-api.js";
export default {
  name: "mySettings",
  data() {
    const validatePass = (rule, value, callback) => {
      var reg =
        /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{6,16}$/;
      if (value.length < 8) {
        callback(new Error("密码至少8位"));
      } else if (!reg.test(value)) {
        callback(new Error("密码必须必须是字母、数字、特殊字符两种以上的组合"));
      } else {
        if (this.psw.NewPwd2 !== "") {
          // 对第二个密码框单独验证
          this.$refs.psw.validateField("NewPwd2");
        }
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value !== this.psw.NewPwd1) {
        callback(new Error("两次密码必须相同"));
      } else {
        callback();
      }
    };
    return {
      showModalPsw: false,
      showModalTel: false,
      showModalEml: false,
      showModalcZ: false,
      showModalCo: false,
      // showcZ:false,
      UserPwdType: "password",
      NewPwd1Type: "password",
      NewPwd2Type: "password",
      TelephoneObj: {},
      editem: {},
      defEditem: {},
      collegeList: [],
      classList: [],
      rule: "",
      psw: {
        UserPwd: "",
        NewPwd1: "",
        NewPwd2: "",
      },
      rulePsw: {
        UserPwd: [{ required: true, message: "密码不能为空", trigger: "blur" }],
        NewPwd1: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
        NewPwd2: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePassCheck, trigger: "blur" },
        ],
      },
      ruleTel: {
        Telephone: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            validator: validatePhoto,
            trigger: "change",
          },
        ],
        Email: [
          { required: true, message: "邮箱账号不能为空", trigger: "blur" },
          {
            validator: validateEmail,
            trigger: "change",
          },
        ],
      },
      ruleValidate: {
        CollegeId: [
          {
            required: true,
            type: "number",
            message: "学院不能为空",
            trigger: "change",
          },
        ],
        // classList: [
        //   { required: true,type:"array", message: "班级不能为空", trigger: "change" },
        // ],
        ClassId: [
          {
            required: true,
            type: "number",
            message: "班级不能为空",
            trigger: "change",
          },
        ],
      },
      ruleEmail: {
        Email: [
          { required: true, message: "邮箱账号不能为空", trigger: "blur" },
          {
            validator: validateEmail,
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    let info = sessionStorage.getItem("userinfo");
    this.rule = JSON.parse(info);
    this.getPhone();
    this.getCollegeArr(); // 获取学院列表
    if (this.rule.Status == "教师") {
      this.getCollegeClass();
    } else {
      this.StGetCollegeClass();
    }
  },
  methods: {
    // 获取学院列表
    async getCollegeArr() {
      this.collegeList = await homeApi.GetCollegeArr();
    },
    async getCollegeClass() {
      let res = await homeApi.getCollegeClass();
      this.defEditem = res.data;
      this.getClassByCollegeId(res.data.CollegeId);
    },
    async StGetCollegeClass() {
      let res = await homeApi.StGetCollegeClass();
      this.defEditem = res.data;
      this.getClassByCollegeId(res.data.CollegeId);
    },

    //根据学院ID获取班级列表
    getClassByCollegeId(val) {
      if (val > 0) {
        this.CollegeId = val;
        homeApi
          .GetClassArr({
            CollegeId: val,
          })
          .then((res) => {
            this.editem.classList = "";
            this.classList = res;
          });
      }
    },

    async getPhone() {
      this.TelephoneObj = await homeApi.GetPhone();
    },

    show(type) {
      if (this[type] == "text") {
        this[type] = "password";
      } else {
        this[type] = "text";
      }
    },
    showModalFn(name, showModalStr) {
      this.$refs[name].resetFields();
      this[showModalStr] = true;
      if (this.rule.Status == "教师") {
        this.editem = {
          CollegeId: this.defEditem.CollegeId,
          classList: this.defEditem.classList,
        };
      } else {
        this.editem = {
          CollegeId: this.defEditem.CollegeId,
          ClassId: this.defEditem.ClassId,
        };
      }
    },
    sureChangePsw(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: "修改密码",
            content: "确认修改密码为" + this.psw.NewPwd1,
            onOk: () => {
              homeApi.NewPwd(this.psw).then((res) => {
                if (res.success) {
                  this.showModalPsw = false;
                  resetTokenAndClearUser();
                  this.$router.push({
                    name: "login",
                  });
                } else {
                  this.$Message.error({
                    content: res.msg,
                    duration: 3,
                  });
                }
              });
            },
          });
        } else {
          this.$Message.error({
            content: "数据不符合要求",
            duration: 3,
          });
        }
      });
    },
    sureChangeTel(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: "修改手机号码",
            content: "确认修改手机号码为" + this.TelephoneObj.Telephone,
            onOk: () => {
              homeApi
                .NewPhone({
                  Telephone: this.TelephoneObj.Telephone,
                })
                .then((res) => {
                  if (res.success) {
                    this.$Message.success({
                      content: res.msg,
                      duration: 3,
                    });
                    this.showModalTel = false;
                  } else {
                    this.$Message.error({
                      content: res.msg,
                      duration: 3,
                    });
                  }
                });
            },
          });
        } else {
          this.$Message.error({
            content: "数据不符合要求",
            duration: 3,
          });
        }
      });
    },
    sureChangeEmail(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: "修改邮箱账号",
            content: "确认修改邮箱账号为" + this.TelephoneObj.Email,
            onOk: () => {
              homeApi
                .NewPhone({
                  Email: this.TelephoneObj.Email,
                })
                .then((res) => {
                  if (res.success) {
                    this.$Message.success({
                      content: res.msg,
                      duration: 3,
                    });
                    this.showModalEml = false;
                  } else {
                    this.$Message.error({
                      content: res.msg,
                      duration: 3,
                    });
                  }
                });
            },
          });
        } else {
          this.$Message.error({
            content: "数据不符合要求",
            duration: 3,
          });
        }
      });
    },

    sureChangeColleg(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.rule.Status == "教师") {
            if (this.editem.classList == "" || this.editem.classList == null) {
              this.$Message.error({
                content: "请选择班级",
                duration: 3,
              });
            } else {
              var editem2 = {
                CollegeId: this.editem.CollegeId,
                classList: this.editem.classList,
              };
              homeApi.collegeClass(editem2).then((res) => {
                this.showModalCo = false;
                if (res.success) {
                  this.$Message.success({
                    content: res.msg,
                    duration: 3,
                  });
                  this.showModalEml = false;
                  this.getCollegeClass();
                } else {
                  this.editem = {};
                  this.$Message.error({
                    content: res.msg,
                    duration: 3,
                  });
                }
              });
            }
          } else {
            var editem3 = {
              CollegeId: this.editem.CollegeId,
              ClassId: this.editem.ClassId,
            };
            homeApi.StGostCollegeClass(editem3).then((res) => {
              this.showModalCo = false;
              if (res.success) {
                this.$Message.success({
                  content: res.msg,
                  duration: 3,
                });
                this.StGetCollegeClass();
                this.showModalEml = false;
              } else {
                this.$Message.error({
                  content: res.msg,
                  duration: 3,
                });
              }
            });
          }
        } else {
          this.$Message.error({
            content: "数据不符合要求",
            duration: 3,
          });
        }
      });
    },
  },
};
</script>